import Container from './Container';
import Content from './Content';

export default {
  Container,
  Content,
};
